module.exports = __webpack_public_path__ + "img/1989SitePlan1983ZoningByLaws_1.e7f1cca6.png";